export default __webpack_public_path__ + "static/media/resume.4236a48d.pdf";